import React from 'react';
import cn from '@utils/cn';
import IconType from '@ui/Icon/StaticIcon/IconType';
import { StaticIcon } from '@ui/Icon/StaticIcon/StaticIcon';
import Text, { TextVariant } from '@ui/Text/Text';

type Props = {
  resetFilters: () => void;
};

const TEXT = 'Your search didn’t reel in any results. Try adjusting the filters or using different keywords.';

export default function TemplateNotFound({ resetFilters }: Props) {
  return (
    <div
      className={cn(
        'flex flex-col gap-8 ',
        'pb-8 pt-8 md:pb-14 md:pt-14 lg:pb-64 lg:pt-32',
        'col-span-4 sm:col-span-6 md:col-span-4 md:col-start-3',
        'lg:col-span-6 lg:col-start-4 xl:col-span-4 xl:col-start-5',
        'items-center justify-center text-center',
        'mx-auto',
      )}
    >
      <StaticIcon icon={IconType.searchNotFound} className="mx-auto" />
      <div className="flex flex-col gap-4">
        <Text content="No templates found." variant={TextVariant.TitleXS} as="p" />
        <Text content={TEXT} variant={TextVariant.TextLabel} />

        <span
          onClick={resetFilters}
          className={cn('decoration-link cursor-pointer select-none hover:underline hover:underline-offset-4')}
        >
          <Text content="Clear filters" variant={TextVariant.SubtitleSM} className="text-link w-full capitalize" />
        </span>
      </div>
    </div>
  );
}
